import { gql } from '@apollo/client/core';

export default gql`
  query OgForwardingDialog {
    getTeamUsers {
      _id
      firstName
      lastName
      email
    }
  }
`;
